<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneOn_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11 8.5a3 3 0 1 1-6 0v-5a3 3 0 1 1 6 0v5Zm1-1a.5.5 0 0 1 1 0v1c0 2.586-1.98 4.694-4.5 4.949V15.5a.5.5 0 0 1-1 0v-2.051C4.98 13.194 3 11.086 3 8.5v-1a.5.5 0 0 1 1 0v1c0 2.206 1.794 4 4 4s4-1.794 4-4v-1Z"
        clip-rule="evenodd"
    />
</svg>
